import { inputStyle } from 'components/elements/Input/Input.styled';
import { styled } from 'styles';

export const StyledTextArea = styled.textarea`
  ${inputStyle};

  height: unset;
  padding: ${({ theme }) => theme.spacing.relative.small}
    ${({ theme }) => theme.spacing.relative.smaller};
  width: 100%;
`;

StyledTextArea.displayName = 'TextArea';
